if (window.location.href.indexOf('catfantasyshop.bonfiregathering.com') > -1) {
	(function () {
		const script = document.createElement('script');
		script.async = true;
		script.src = 'https://connect.facebook.net/en_US/fbevents.js';
		document.head.appendChild(script);

		window.fbq = function () {
			if (window.fbq.callMethod) {
				window.fbq.callMethod.apply(window.fbq, arguments);
			} else {
				window.fbq.queue.push(arguments);
			}
		};
		if (!window._fbq) window._fbq = window.fbq;
		window.fbq.push = window.fbq;
		window.fbq.loaded = true;
		window.fbq.version = '2.0';
		window.fbq.queue = [];

		window.fbq('init', '1557718204892863');
		window.fbq('track', 'PageView');
	})();

	(function () {
		const script = document.createElement('script');
		script.async = true;
		script.src = 'https://www.googletagmanager.com/gtag/js?id=G-J9ZJ5EV26T';
		document.head.appendChild(script);

		window.dataLayer = window.dataLayer || [];
		function gtag() {
			dataLayer.push(arguments);
		}
		window.gtag = gtag;

		gtag('js', new Date());
		gtag('config', 'G-J9ZJ5EV26T');
	})();
}
